export function getGoogleClientId(): string {
  const metaTag = document.querySelector('meta[name="google-client-id"]');
  if (metaTag instanceof HTMLMetaElement) {
    return metaTag ? metaTag.content : '';
  }
  return '';
}

export function trackGoogleOneTapHandshakeSuccess(): void {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'GoogleOneTapHandshakeSuccess',
  });
}

export function trackGoogleOneTapClicked(selectBy: string): void {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'GoogleOneTapClicked',
    data: {
      selectBy,
    },
  });
}

export function trackGoogleOneTapNotDisplayed(
  notDisplayedReason: string,
  dismissedReason: string
): void {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'GoogleOneTapNotDisplayed',
    data: {
      notDisplayedReason,
      dismissedReason,
    },
  });
}

export function trackGoogleOneTapDisplayed(): void {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'GoogleOneTapDisplayed',
  });
}

export function reloadToGetUserGoogleData(): void {
  let { search } = window.location;
  const { pathname, hash } = window.location;

  search = search === '' ? '?from_google_sso=true' : `${search}&from_google_sso=true`;

  const newURL = pathname + search + hash;

  window.location.href = newURL;
}

export function sanitizeAndCombineUrl(redirectUrl: string, search: string): string {
  if (!search) {
    // if the search string is empty or null, just return the redirectUrl
    return redirectUrl;
  }
  if (!redirectUrl.includes('?')) {
    // if the redirectUrl doesn't have a ?, just concatenate them
    return redirectUrl + search;
  }
  // if the redirectUrl already has a ?, replace the ? in search with an &
  return redirectUrl + search.replace('?', '&');
}
